import { render, staticRenderFns } from "./PointDelivery.vue?vue&type=template&id=e10c7a12&scoped=true"
import script from "./PointDelivery.vue?vue&type=script&lang=js"
export * from "./PointDelivery.vue?vue&type=script&lang=js"
import style0 from "./PointDelivery.vue?vue&type=style&index=0&id=e10c7a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10c7a12",
  null
  
)

export default component.exports